import request from '@/utils/request';
import {decrypt} from "@/utils/crypto";

// addAdvert
export function addAdvert(data) {
  return request({
    url: '/advert/addAdvert',
    method: 'post',
    data
  });
}
// editAdvert
export function editAdvert(data) {
  return request({
    url: '/advert/edit',
    method: 'put',
    data
  });
}
export function addAdverts(data) {
  return request({
    url: '/advert/addAdverts',
    method: 'post',
    data
  });
}

// advert/delAdvert
export function delAdvert(data) {
  return request({
    url: '/advert/delAdvert',
    method: 'delete',
    params: data
  });
}

// advert/getAdvertList
export function getAdvertList(data) {
  return request({
    url: '/advert/getAdvertList',
    method: 'get',
    params: data
  });
}

// advert/useAdvert
export function useAdvert(data) {
  return request({
    url: '/advert/useAdvert',
    method: 'get',
    params: data
  });
}
// 网站设置
export function webConfigsave(data) {
  return request({
    url: 'webConfig/save',
    method: 'put',
    data
  });
}
export function webConfiGetById(data) {
  return request({
    url: '/webConfig/queryAllById',
    method: 'get',
    params: data
  });
}

export async function webConfigetDefault(data) {
    let res = await request({
        url: '/webConfig/getDefault',
        method: 'get',
    });
    if(decrypt(res.data) != null){
        res.data = decrypt(res.data);
    }
    return res;
}


//授权
export function authPlatForm(data) {
  return request({
    url: '/auth/platForm',
    method: 'post',
    data
  });
}

//签约
export function signSharingAgreement(data) {
  return request({
    url: '/auth/signSharingAgreement',
    method: 'get',
    params: data
  });
}

//代理商查询明细
export function merchantInfoQuery(data) {
  return request({
    url: '/auth/merchantInfoQuery',
    method: 'get',
    params: data
  });
}


//进件链接
export function getMerchantUrl(data) {
  return request({
    url: '/auth/merchantCreateUrl',
    method: 'get',
    params: data
  });
}